import React, { useState, useEffect } from 'react';
import useCallStore, { CALL_STATUS } from '../state/application/useCallStore';

// Floating active-call banner, top-right while a call is active.
export default function PhoneCallBanner() {
  const callStatus     = useCallStore(s => s.callStatus);
  const callingPatient = useCallStore(s => s.callingPatient);
  const callStartTime  = useCallStore(s => s.callStartTime);
  const disconnect     = useCallStore(s => s.disconnect);

  const [elapsed, setElapsed] = useState(null);

  // Timer: tick every 500 ms while connected
  useEffect(() => {
    if (callStatus !== CALL_STATUS.CONNECTED || !callStartTime) {
      setElapsed(null);
      return;
    }
    const interval = setInterval(() => {
      const totalSec = Math.floor((Date.now() - callStartTime) / 1000);
      const mins = Math.floor(totalSec / 60);
      const secs = totalSec - mins * 60;
      setElapsed(`${mins}:${String(secs).padStart(2, '0')}`);
    }, 500);
    return () => clearInterval(interval);
  }, [callStatus, callStartTime]);

  if (!callingPatient) return null;

  const isDisconnected = callStatus === CALL_STATUS.DISCONNECTED;

  return (
    <div className="phone-call-banner">
      {/* Pulse indicator */}
      <div className={`phone-call-pulse ${callStatus === CALL_STATUS.CONNECTED ? 'connected' : ''}`} />

      {/* Name + timer */}
      <div className="phone-call-info">
        <span className="phone-call-name">{callingPatient.name}</span>
        <span className="phone-call-timer">
          {callStatus === CALL_STATUS.DIALING && 'Calling\u2026'}
          {callStatus === CALL_STATUS.CONNECTED && (elapsed || '--:--')}
          {isDisconnected && 'Ended'}
        </span>
      </div>

      {/* Hangup */}
      <button
        className={`phone-call-hangup ${isDisconnected ? 'disabled' : ''}`}
        onClick={disconnect}
        disabled={isDisconnected}
        title="Hang up"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 11.94 11.94 0 0 0 3.75.6 2 2 0 0 1 2 2v3.29a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-5.84-5.84 19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 5.49 2h3.29a2 2 0 0 1 2 1.72 12.05 12.05 0 0 0 .57 2.57" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
      </button>
    </div>
  );
}
